module.exports = __webpack_public_path__ + "static/media/emailreporting.39f9e982.svg";